const KEY = 'history';

/**
 * Append a query to the «آخرین جستجوهای شما» list (localStorage `history`, newest last).
 * Blank queries (e.g. `/s/?text=`) are ignored — they used to render as an empty grey chip.
 */
export function pushSearchHistory(value: unknown) {
  if (typeof value !== 'string' || value.trim() === '') return;
  try {
    const history: unknown[] = JSON.parse(localStorage.getItem(KEY) ?? '[]') ?? [];
    const rest = Array.from(new Set(history)).filter(item => item !== value);
    localStorage.setItem(KEY, JSON.stringify([...rest, value]));
  } catch {
    // Private mode / corrupted value: history is a convenience, never block a search.
  }
}
